var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('StoryblokStoryWrapper',{attrs:{"path":"_templateId"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var blok = ref.blok;
return [(blok)?_c('TemplatesLandingPage',{attrs:{"blok":blok}}):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }